import { authHeader, handleResponse } from '../../utils';
import type { IPostcodeLookupResponse } from '../../customTypings/address/PostalAddress';

export const postcodeService = {
  lookup,
};

function lookup(postcode: string, countryCode = 'uk'): Promise<IPostcodeLookupResponse> {
  const requestOptions: RequestInit = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ postcode, countryCode }),
  };
  return fetch('/api/address-lookup/by-postcode', requestOptions).then(handleResponse);
}